import { render, staticRenderFns } from "./newPlan.vue?vue&type=template&id=8d6b8826&"
import script from "./newPlan.vue?vue&type=script&lang=js&"
export * from "./newPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports